import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
/**
 * Wrapper que entrega o padrão de nav mobile usado pelas páginas do
 * tema Avocado: em desktop fica escondido, em mobile escapa via CSS
 * do Avocado (position:absolute) pro header — é o que aciona o
 * `App-titleControl` (SelectDropdown) na barra superior do celular.
 *
 * SEM o tema Avocado o helper não tem como "escapar" — o nav fica em
 * fluxo normal e empurra o conteúdo da página inteira pra baixo. Por
 * isso retornamos null nesse caso. Detecção é feita via `app.extensions`,
 * com fallback pra classe `avocado-theme` que o próprio tema adiciona
 * em <html> no boot.
 *
 * Uso: `{MpNavHelper()}` no topo de cada Page do marketplace.
 */
export function MpNavHelper() {
  if (!isAvocadoActive()) return null;
  return m("div", {
    className: "AvocadoNav-helper MpNav-helper"
  }, m(IndexSidebar, null));
}

/**
 * Tela de "não encontrado" para páginas de curso quando o módulo está
 * desativado no admin (`marketplace_course_enabled` = false). O backend já
 * responde 404 nos endpoints; aqui evitamos chamar a API e mostramos o
 * equivalente de 404 na SPA, com link de volta à loja.
 */
export function renderCoursesUnavailable() {
  const t = k => app.translator.trans('ramon-marketplace.forum.courses.' + k);
  return m("div", {
    className: "MarketplacePage MpCourses"
  }, MpNavHelper(), m("div", {
    className: "container"
  }, m("div", {
    className: "MpCourses-empty MpEmpty"
  }, m("i", {
    className: "fas fa-graduation-cap"
  }), m("p", null, t('module_disabled') || 'Os cursos não estão disponíveis.'), m("a", {
    href: app.route('marketplace.shop'),
    config: m.route.link,
    className: "MpBtn MpBtn--primary"
  }, t('go_shop') || 'Ir à loja'))));
}
export function coursesEnabled() {
  return !!app.forum.attribute('marketplace_course_enabled');
}
function isAvocadoActive() {
  const exts = app.extensions;
  if (exts && (exts['ramon/avocado'] || exts['ramon-avocado'])) return true;
  if (typeof document !== 'undefined' && document.documentElement.classList.contains('avocado-theme')) {
    return true;
  }
  return false;
}
flarum.reg.add('ramon-marketplace', 'forum/components/MpNavHelper', { MpNavHelper: MpNavHelper,renderCoursesUnavailable: renderCoursesUnavailable,coursesEnabled: coursesEnabled, });